module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Rothenfluh-9d83e161f5a7d9ac0871d33ebcc5916a.svg";